import { render } from "./GoldTypesPage.vue?vue&type=template&id=ad732888"
import script from "./GoldTypesPage.vue?vue&type=script&lang=js"
export * from "./GoldTypesPage.vue?vue&type=script&lang=js"

import "./GoldTypesPage.vue?vue&type=style&index=0&id=ad732888&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__